import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { ImageLazyLoad, FeedImage } from '../../';
import { generateSnapshotUrl } from '../../../utils';
import './styles.scss';

const propTypes = {
  feed: PropTypes.object,
};

class LiveCamResult extends React.Component {

  constructor(props) {
    super(props);
    this.state = { snapshotSrc: null, retryCount: 0}
    this.navigateToFeed = this.navigateToFeed.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  generateHtml(content){
    return {__html: content};
  }

  navigateToFeed(feed, e) {
    e.preventDefault();
    browserHistory.push(`/livecams/${feed.cam_group.slug}/${feed.slug}`);
  }

  componentWillMount() {
    this.setState({snapshotSrc: this.props.feed.snapshot});
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.feed.snapshot !== this.state.snapshotSrc) {
      this.setState({snapshotSrc: this.props.feed.snapshot, retryCount:0});
    }
  }

  handleError() {
    let {snapshotSrc, retryCount} = this.state;
    if(retryCount < 10) {
      let matches = snapshotSrc.match(/\/([a-zA-z-]*)-EDGE.*(\d{10})/);
      if(matches.length < 3) return;
      let template = matches[1];
      let timestamp = matches[2];
      if(timestamp) {
        snapshotSrc = generateSnapshotUrl(template, (parseInt(timestamp)+1));
        retryCount++;
        this.setState({snapshotSrc, retryCount});
      }
    }
  }

  render() {
    const { feed } = this.props;
    let loaderProps = {
      style: {
        width:'100%',
        paddingBottom:'56.25%',
        position:'relative',
      },
      dark: true,
    };

    let feedClasses = 'result-info-box cam-item';

    if (feed.is_inactive) {
      switch (feed.offline_label) {
        case 'Meditation':
          feedClasses += ' is-meditation';
          break;
        case 'Film':
          feedClasses += ' is-film';
          break;
        case 'Highlights':
          feedClasses += ' is-offline';
          break;
        case 'Off Season':
          feedClasses += ' is-off-season';
          break;
        default:
          feedClasses += '';
      }
    } else {
      feedClasses += feed.force_offline ? '' : ' is-online';
    }
    return (
      <div className="row search-result-item livecam-result" onClick={(e) => this.navigateToFeed(feed, e)}>
        <div className="col d-none d-sm-block result-poster">
          <img src={feed.cam_group.poster_url} />
        </div>
        <div className="col result-info-box-wrapper">
          <div className={feedClasses}>
            <div className="live-cam-label-wrap">
            <div className="live-cam-label">
                Watch LiveCam
                {feed.current_viewers > 0 &&
                  <div>
                    <div className="live-cam-label-separator"></div>
                    <div className="cam-group-count">{feed.current_viewers}</div> viewers
                  </div>
                }
              </div>
            </div>
            {feed.thumbnail_large_url &&
              <FeedImage
                template={feed.recordings_template}
                timestamp={Math.round(new Date().getTime() / 1000)}
                style={{minHeight:'100%'}}
                loaderProps={loaderProps}
                fallbackImgSrc={feed.thumbnail_large_url}
              />
            }
            <div className="result-text-info p-15">
              <h2 className="result-title">{feed.title}</h2>
              <div className="result-location">{feed.location_text}</div>
              <div dangerouslySetInnerHTML={this.generateHtml(feed.description)} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

LiveCamResult.propTypes = propTypes;

export default LiveCamResult;
